"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageWrap = exports.SectionWrap = exports.styles = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styles = (theme) => ({
    root: {
        height: '100%',
        padding: '12px 12px 12px 6px',
    },
    checkboxLabel: {
        width: '100%',
    },
    itemWrap: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: '1px',
        background: 'transparent',
        height: '35px !important',
        marginBottom: 8,
        marginRight: -5,
        '&:hover': {
            background: theme.palette.background.layer1,
        },
    },
    labelTextLayout: {
        background: 'transparent',
        border: 'none',
        padding: '0 6px 0 0',
        flexGrow: 1,
        height: '100%',
        '&:focus': {
            outline: 0,
        },
        '&:hover': {
            cursor: 'pointer',
        },
    },
    labelText: {
        textAlign: 'left',
        fontSize: 13,
        fontWeight: 400,
        paddingRight: 5,
        color: theme.palette.text.primary,
        position: 'relative',
    },
    labelTextSelected: {
        textAlign: 'left',
        fontSize: 13,
        fontWeight: 400,
        paddingRight: 5,
        position: 'relative',
        color: theme.palette.text.strong,
    },
    customCheckBox: {
        height: 24,
        width: 24,
        fontSize: 13,
        borderRadius: 3,
        backgroundColor: theme.palette.background.subtle,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme.palette.text.strong,
        fontWeight: 400,
    },
    customCheckBoxChecked: {
        height: 24,
        width: 24,
        fontSize: 13,
        borderRadius: 3,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.text.contrastText,
        fontWeight: 500,
    },
    payeeName: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: 13,
        letterSpacing: 'normal',
    },
    payeeCheckbox: {
        height: '40px !important',
    },
    link: {
        color: theme.palette.link.main,
        textDecoration: 'none',
        '& :hover': {
            textDecoration: 'none',
        },
    },
    btnStyle: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingRight: 10,
    },
});
exports.styles = styles;
const SectionWrap = styled_components_1.default.div `
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
exports.SectionWrap = SectionWrap;
const PageWrap = styled_components_1.default.div `
  height: 100%;
  width: 100%;
`;
exports.PageWrap = PageWrap;
